module.exports = __webpack_public_path__ + "img/3f8467afa05441d40dda298b5a50ea45.png";